export function stripPhoneMask (phoneNumber) {
    return phoneNumber.replace(/[ )(-]/g, '');
}